import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NavController, PopoverController } from '@ionic/angular';
import { BusinessLogicService } from 'src/app/services/business-logic.service';
import { FireService } from 'src/app/services/fire.service';
import { HelperService } from 'src/app/services/helper.service';
import { PassParametersService } from 'src/app/services/pass-parameters.service';

@Component({
  selector: 'app-menu-desktop',
  templateUrl: './menu-desktop.component.html',
  styleUrls: ['./menu-desktop.component.scss'],
})
export class MenuDesktopComponent implements OnInit {

  @Output()
  logout: EventEmitter<any> = new EventEmitter();

  constructor(
    private businessLogicService: BusinessLogicService,
    public popoverController: PopoverController,
    public fireService: FireService,
    public navCtrl: NavController,
    public passParametersService: PassParametersService,
    public helper: HelperService,
  ) { }

  ngOnInit() {
  }

  logoutFx() {
    this.logout.emit("");
  }

  async toggleShowSearch() {
    this.businessLogicService.toggleShowSearch();
    await this.popoverController.dismiss();
  }

  getAddButtonText() {
    // return this.businessLogicService.getAddButtonText();
  }

  async onClickAdd() {
    await this.popoverController.dismiss();
    // this.businessLogicService.onClickAddButton()
  }

  async onClickUser() {

    // const userDoc = await this.fireService.getUserDoc();
    // if (!userDoc) {
    //   this.helper.toast("Error loading user profile.");
    //   return;
    // }

    // console.log("userDoc", userDoc as User);

    // this.passParametersService.setUser(userDoc.data as User);
    this.navCtrl.navigateForward(`/app/main/user`);
    await this.popoverController.dismiss();
  }


}
